$(function() {
	
	var openClass	= 'open';
	
	$('[data-toggle="sidepanel"]').each(function() {
		var target = $(this).data('target'),
			$target = $(target);
			
		$(this).on('click', function() {
			$target.toggleClass(openClass);
		});
		
		$target.find('.background').on('click', function() {
			$target.removeClass(openClass);
		});
	});
});